import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "a[ui-external-link]",
  // inline template is used to avoid adding white space between the projected content and the icon
  template: `<ng-content></ng-content><i ui-icon uiType="external-link"></i>`,
  styleUrls: ["external-link.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiExternalLinkComponent {}
